<template>
  <!-- eslint-disable-next-line prettier/prettier -->
  <router-link
    :to="link"
    :class="['bttn', size, outline ? 'outline' : 'solid']"
  >
    <span class="icon icon--before">
      <slot name="icon-before"></slot>
    </span>

    <slot name="button-text"></slot>
    <span class="icon icon--after">
      <slot name="icon-after"></slot>
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'ButtonLink',
  props: {
    size: {
      type: String,
      default: 'normal',
      // eslint-disable-next-line
      validator: function (value) {
        // The value must match one of these strings
        return ['normal', 'md', 'sm'].indexOf(value) !== -1;
      },
    },
    outline: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.bttn {
  height: 100%;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;

  font-weight: 400;
}

.normal {
  font-size: 16px;
  padding: 8px 16px;
  letter-spacing: 1px;
  line-height: 16px;

  .icon--before {
    font-size: 16px;
    margin-right: 8px;
  }

  .icon--after {
    margin-left: 8px;
    height: 15px;
    width: auto;
  }
}

.md {
  padding: 8px 16px;
  font-size: 16px;
  letter-spacing: 0.5px;

  .icon--before {
    margin-right: 4px;
  }

  .icon--after {
    margin-left: 4px;
  }
}

.sm {
  padding: 4px 8px;
  font-size: 12px;
  letter-spacing: 0.5px;

  .icon--before {
    margin-right: 4px;
  }

  .icon--after {
    height: 12px;
    margin-left: 4px;
  }
}

.solid {
  color: hsl(var(--clr-primary-100));
  background-color: hsl(var(--clr-primary-700));
}

.outline {
  border: 1px solid hsl(var(--clr-primary-100));
  color: hsl(var(--clr-primary-100));
  background-color: transparent;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: hsl(var(--clr-primary-700));
    color: hsl(var(--clr-primary-100));
  }
}

@media (max-width: 900px) {
  .normal {
    font-size: 12px;
  }
}
</style>
